import { useEffect, useState } from 'react';

/** Measures container width via ResizeObserver. */
export function useContainerMeasurement(
  containerRef?: React.RefObject<HTMLDivElement>
) {
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const measureWidth = () => {
      if (containerRef?.current) {
        setContainerWidth(containerRef.current.clientWidth);
      }
    };

    measureWidth();

    const resizeObserver = new ResizeObserver(measureWidth);
    if (containerRef?.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, [containerRef]);

  return {
    containerWidth,
  };
}
